// Copied from apps/admin/src/pages/dashboard/gps-tracking/lib/constants.ts (PRD #875).
export const DEFAULT_MAP_CENTER: [number, number] = [43.238949, 76.889709];
export const DEFAULT_MAP_ZOOM = 13;
